import { render, staticRenderFns } from "./Received-Line-Item.vue?vue&type=template&id=0b6d2ee4"
import script from "./Received-Line-Item.vue?vue&type=script&lang=js"
export * from "./Received-Line-Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports